<app-header [titleName]="'REGISTER-FUEL--FUELING-LABEL' | translate"></app-header>

<ion-content class="ion-padding" [style.--background]="customerColor">
  <main>
    <p class="fuel-description">{{"REGISTER-FUEL--REFUELING" | translate}}</p>
    <form [formGroup]="fuelForm" (ngSubmit)="submitFuelRegister()">
      <ion-item>
        <ion-select
          formControlName="vehicleId"
          label="{{'REGISTER-FUEL--VEHICLE' | translate}}"
          labelPlacement="stacked"
          >
          @for (vehicle of vehicleList; track vehicle) {
            <ion-select-option
              [value]="vehicle.id"
              >
              {{ vehicle.name }}
            </ion-select-option>
          }
        </ion-select>
      </ion-item>

      <ion-item>
        <ion-select
          formControlName="driverId"
          placeholder="{{'REGISTER-FUEL--SELECT' | translate}} ..."
          label="{{'REGISTER-FUEL--DRIVER' | translate}}:"
          labelPlacement="stacked"
          >
          @for (driver of driversList; track driver) {
            <ion-select-option
              [value]="driver.id"
              >
              {{ driver.nome }}
            </ion-select-option>
          }
        </ion-select>
      </ion-item>

      <ion-item>
        <div class="fuel-place-container">
          <div class="about-fuel-place">
            <small
              [ngClass]="{
                'input-invalid':
                  fuelForm.get('fuelAddressId')?.invalid && fuelForm.get('fuelAddressId')?.touched,
                'input-valid':
                  fuelForm.get('fuelAddressId')?.valid && fuelForm.get('fuelAddressId')?.touched,
              }"
              >{{"REGISTER-FUEL--LOCATION" | translate}}:</small
              >
              <ion-label>{{ fuelPlaceLabel || select }}</ion-label>
            </div>
            <ion-button
              expand="block"
              fill="outline"
              size="default"
              (click)="editPlacesModal()"
              [style.--border-color]="customerColor"
              ><ion-icon
              name="pencil-sharp"
              [style.color]="customerColor"
              class="address-option-btn"
              ></ion-icon
            ></ion-button>
          </div>
        </ion-item>

        <ion-item>
          <ion-select
            formControlName="supplierId"
            placeholder="{{'REGISTER-FUEL--SELECT' | translate}} ..."
            label="{{'REGISTER-FUEL--SUPPLIER' | translate}}:"
            labelPlacement="stacked"
            >
            @for (supplier of suppliersList; track supplier) {
              <ion-select-option
                [value]="supplier.id"
                >
                {{ supplier.nome }}
              </ion-select-option>
            }
          </ion-select>
        </ion-item>

        <ion-item>
          <ion-input
            formControlName="nfNumber"
            label="{{'REGISTER-FUEL--INVOICE' | translate}}:"
            label-placement="stacked"
            type="number"
          ></ion-input>
        </ion-item>

        <ion-item>
          <ion-input
            formControlName="fuelTotalPrice"
            label="{{'REGISTER-FUEL--AMOUNT' | translate}}:"
            label-placement="stacked"
            type="number"
          ></ion-input>
        </ion-item>

        <ion-item>
          <ion-input
            formControlName="fuelLiters"
            label="{{'REGISTER-FUEL--LITERS' | translate}}:"
            label-placement="stacked"
            type="number"
          ></ion-input>
        </ion-item>

        <ion-item>
          <ion-select
            formControlName="fuelTypeSupplied"
            placeholder="{{'REGISTER-FUEL--SELECT' | translate}} ..."
            label="{{'REGISTER-FUEL--TYPE' | translate}}:"
            labelPlacement="stacked"
            >
            @for (tipo of fuelTypes; track tipo) {
              <ion-select-option [value]="tipo">
                {{tipo}}
              </ion-select-option>
            }
          </ion-select>
        </ion-item>

        <ion-item>
          <ion-input
            formControlName="hodometer"
            label="{{'REGISTER-FUEL--ODOMETER' | translate}}:"
            maxlength="6"
            max="999999"
            labelPlacement="stacked"
            type="number"
          ></ion-input>
        </ion-item>

        <ion-item>
          <ion-input
            label="{{'REGISTER-FUEL--HOURMETER' | translate}}"
            labelPlacement="stacked"
            type="number"
            formControlName="horimetro"
            inputmode="decimal"
            min="0"
            step="0.1"
            >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-input
            formControlName="observation"
            type="text"
            label="{{'REGISTER-FUEL--NOTE' | translate}}:"
            labelPlacement="stacked"
          ></ion-input>
        </ion-item>

        <ion-card>
          <img
            [src]="proofFuelRegisterImgB64 || 'assets/default-img.png'"
            alt="{{'REGISTER-FUEL--ONLY-RECEIPT' | translate}}"
            />

          <ion-card-content>
            @if (
              fuelForm.get('proofFuelRegister')?.invalid &&
              fuelForm.get('proofFuelRegister')?.touched
              ) {
              <ion-note
                color="danger"
                >
                <p style="width: 100%; text-align: center">
                  {{"REGISTER-FUEL--RECEIPT" | translate}}
                </p>
              </ion-note>
            }

            <ion-button
              expand="block"
              fill="outline"
              (click)="takePicture()"
              [style.--border-color]="customerColor"
              [style.color]="customerColor"
              >
              {{"REGISTER-FUEL--PHOTO" | translate}}
            </ion-button>
          </ion-card-content>
        </ion-card>

        <ion-button expand="block" type="submit" color="success">
          {{"REGISTER-FUEL--SUBMIT" | translate}}
        </ion-button>
      </form>
    </main>
  </ion-content>
